/* ============================================================
   TRITON · POSEIDON — behavior
   THE CUT reveals, scroll choreography, count-up, type toggle,
   sticky buy bar, WhatsApp-primary buy wiring. No dependencies.
   ============================================================ */
(function () {
  "use strict";
  var D = window.TRITON_DATA || {};
  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  /* reveal gate: hide-for-animation ONLY when JS runs and motion is welcome.
     no-JS visitors, crawlers, and reduced-motion users get fully-visible content
     at first paint (the opacity:0 initial state is scoped to html.js-reveal in CSS). */
  if (!reduce) document.documentElement.classList.add("js-reveal");
  var wa = D.whatsapp || {};
  var waUrl =
    "https://wa.me/" +
    (wa.number || "") +
    (wa.message ? "?text=" + encodeURIComponent(wa.message) : "");

  /* ---- hero headline: split slogan into rising words ---- */
  var h1 = document.getElementById("heroH1");
  if (h1) {
    var words = (D.slogan || "הדיוק מתחיל כאן").split(" ");
    h1.innerHTML = words
      .map(function (w, i) {
        var delay = reduce ? 0 : 0.35 + i * 0.14;
        return (
          '<span class="word" style="animation-delay:' +
          delay +
          's">' +
          w +
          "</span>"
        );
      })
      .join(" ");
  }

  /* Defensive cleanup: remove accidental local Windows screenshot paths if a
     browser, theme setting, or editor paste leaks them into visible text. */
  (function scrubLocalScreenshotPaths() {
    var localScreenshotPath = /[A-Z]:\\Users\\[^\\]+\\Desktop\\Screenshot\s+\d{4}-\d{2}-\d{2}\s+\d{6}\.(png|jpe?g|webp)/i;
    var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);
    var nodes = [];
    while (walker.nextNode()) {
      if (localScreenshotPath.test(walker.currentNode.nodeValue || "")) {
        nodes.push(walker.currentNode);
      }
    }
    nodes.forEach(function (node) {
      var parent = node.parentElement;
      if (parent && parent.textContent.trim() === node.nodeValue.trim()) {
        parent.remove();
      } else {
        node.nodeValue = node.nodeValue.replace(localScreenshotPath, "");
      }
    });
    document.querySelectorAll("img[alt], img[src]").forEach(function (img) {
      if (localScreenshotPath.test(img.getAttribute("alt") || "")) {
        img.setAttribute("alt", "");
      }
      if (localScreenshotPath.test(img.getAttribute("src") || "")) {
        img.remove();
      }
    });
  })();

  /* ---- buy buttons: demo action = WhatsApp; store link stays secondary ---- */
  if (D.buyMode === "whatsapp") {
    document.querySelectorAll("[data-buy]").forEach(function (el) {
      el.setAttribute("href", waUrl);
      el.setAttribute("target", "_blank");
      el.setAttribute("rel", "noopener");
    });
  }

  /* ---- honesty gate: claims flagged unconfirmed in data.js `confirmed` must not
     assert as fact on a real brand. Hard / unverifiable claims (the ₪499 anchor,
     the TikTok link, Made-in-Israel) are hidden until the flag flips true. Soft
     spec/positioning copy (runtime "up to 3.5h", local-service warranty) stays. ---- */
  var confirmed = D.confirmed || {};
  var GATE_HIDE = { price: true, tiktok: true, "made-in-israel": true };
  document.querySelectorAll("[data-gate]").forEach(function (el) {
    var key = el.getAttribute("data-gate");
    if (confirmed[key]) return; // confirmed → render as-is
    if (GATE_HIDE[key]) el.style.display = "none";
  });


  /* ---- nav solid-on-scroll ---- */
  var nav = document.getElementById("nav");
  function onScroll() {
    var scrolled = window.scrollY > 40;
    if (nav) nav.classList.toggle("scrolled", scrolled);
    document.body.classList.toggle("is-scrolled", scrolled);
  }
  onScroll();
  window.addEventListener("scroll", onScroll, { passive: true });

  /* ---- count-up (preserves a trailing <small> sibling) ---- */
  function countUp(el, dur) {
    if (!el) return;
    var node = el.firstChild;
    if (!node || node.nodeType !== 3) return;
    var txt = node.nodeValue.trim();
    var m = txt.match(/^([\d.,]+)/);
    if (!m) return;
    var suffix = txt.slice(m[1].length); // keep "g" in "167g", etc.
    var hasComma = m[1].indexOf(",") >= 0;
    var dec = m[1].indexOf(".") >= 0 ? (m[1].split(".")[1] || "").length : 0;
    var target = parseFloat(m[1].replace(/,/g, ""));
    if (isNaN(target)) return;
    function fmt(n) {
      var s =
        dec > 0
          ? n.toFixed(dec)
          : hasComma
            ? Math.round(n).toLocaleString("en-US")
            : String(Math.round(n));
      return s + suffix;
    }
    if (reduce) {
      node.nodeValue = fmt(target);
      return;
    }
    dur = dur || 1200;
    var t0 = performance.now();
    node.nodeValue = fmt(0);
    function tick(t) {
      var p = Math.min(1, (t - t0) / dur);
      var v = target * (1 - Math.pow(1 - p, 3));
      node.nodeValue = fmt(v);
      if (p < 1) requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  /* ---- reveal / stagger via one observer (spec-step counts run in the
     engineering stage engine below, not here) ---- */
  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add("in");
        io.unobserve(e.target);
      });
    },
    { threshold: 0.18, rootMargin: "0px 0px -8% 0px" },
  );
  document.querySelectorAll(".reveal, .stagger").forEach(function (el) {
    io.observe(el);
  });
  /* ---- THE CUT wipe scarcity: only the dividers into the three showpiece
     seams (engineering, reviews, buy) animate their gold wipe. Every other
     divider renders pre-lit static (.prelit) so it stays a visible hairline
     but never spends the motion vocabulary. ---- */
  var ANIMATED_CUTS = { engineering: 1, reviews: 1, buy: 1 };
  document.querySelectorAll("[data-cut]").forEach(function (cut) {
    var wrapper = cut.closest(".shopify-section");
    var sec = wrapper ? wrapper.querySelector("section[id]") : null;
    if (sec && ANIMATED_CUTS[sec.id]) {
      io.observe(cut);
    } else {
      cut.classList.add("prelit");
    }
  });
  /* failsafe: content must never stay invisible. The observer plays the on-scroll
     reveal, but JS-but-no-scroll (bots, screenshot tools) and instant jump-scrolls
     can skip it. A plain timer (NOT the load event, which the hero/reel videos
     delay for seconds) force-reveals anything still hidden so nothing stays at
     opacity:0. Fires soon enough that a fast scroller never meets a blank band. */
  function revealAll() {
    document
      .querySelectorAll(
        ".reveal:not(.in), .stagger:not(.in), [data-cut]:not(.in):not(.prelit)",
      )
      .forEach(function (el) {
        el.classList.add("in");
      });
  }
  setTimeout(revealAll, 1400);

  /* ---- sticky buy bar: show once the hero CTA leaves the viewport ---- */
  var heroCta = document.querySelector("#hero [data-buy]");
  var stickybar = document.getElementById("stickybar");
  if (heroCta && stickybar) {
    var sbIo = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          stickybar.classList.toggle("show", !e.isIntersecting);
        });
      },
      { threshold: 0 },
    );
    sbIo.observe(heroCta);
  }

  /* ---- desktop-only hero parallax: two planes, rAF-throttled. The stage
     (which carries the product) tracks scroll faster than the far haze, so the
     hero reads with depth. Skip touch / reduced-motion. The prodrise intro now
     uses a `backwards` fill (see CSS) so it no longer pins the product's
     transform after it plays, which is what made this a no-op before. ---- */
  var canParallax =
    window.matchMedia("(hover: hover) and (pointer: fine)").matches && !reduce;
  if (canParallax) {
    var hStage = document.querySelector(".hero-stage");
    var hHaze = document.querySelector(".hero-haze");
    if (hStage || hHaze) {
      var pTicking = false;
      window.addEventListener(
        "scroll",
        function () {
          if (pTicking) return;
          pTicking = true;
          requestAnimationFrame(function () {
            var y = Math.min(window.scrollY, 700);
            if (hStage)
              hStage.style.transform =
                "translateY(" + (y * 0.06).toFixed(2) + "px)";
            if (hHaze)
              hHaze.style.transform =
                "translateY(" + (y * 0.03).toFixed(2) + "px)";
            pTicking = false;
          });
        },
        { passive: true },
      );
    }
  }

  /* ---- engineering set-piece: "THE CALIPER" stage engine. As each stat
     crosses the viewport center, the caliper line glides to the part of the
     product it measures, the matching frame light crossfades in, the rail
     focus moves, the number counts up once, and a gold strike settles under
     it. Stage 4 retracts the line and swells the floor pool. Bidirectional:
     scrolling back scrubs the stages without re-counting. Skipped under
     reduced motion (numbers stay server-rendered finals). ---- */
  if (!reduce) {
    var spectacle = document.querySelector("#engineering .spectacle");
    var steps = spectacle
      ? Array.prototype.slice.call(spectacle.querySelectorAll(".spec-step"))
      : [];
    if (spectacle && steps.length) {
      var fireStep = function (step) {
        if (step.dataset.counted) return; // count once, never on scroll-back
        step.dataset.counted = "1";
        var num = step.querySelector(".num");
        var hasDigits = num && /\d/.test(num.textContent);
        if (hasDigits) countUp(num, 1500);
        // strike settles after the count (or shortly, for the digitless DLC step)
        setTimeout(
          function () {
            step.classList.add("counted");
          },
          hasDigits ? 1500 : 250,
        );
      };
      var setActive = function (idx) {
        spectacle.dataset.stage = String(idx + 1);
        steps.forEach(function (s, i) {
          s.classList.toggle("is-active", i === idx);
        });
        fireStep(steps[idx]);
      };
      var stageIo = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) {
            if (!e.isIntersecting) return;
            var idx = steps.indexOf(e.target);
            if (idx >= 0) setActive(idx);
          });
        },
        { rootMargin: "-42% 0px -42% 0px", threshold: 0 },
      );
      steps.forEach(function (s) {
        stageIo.observe(s);
      });
    }
  }

  /* ---- play hero + reel videos when in view; pause when off-screen (perf +
     battery, no visual change). Reduced-motion users keep the poster. ---- */
  if (!reduce) {
    var vids = Array.prototype.slice.call(
      document.querySelectorAll("video[data-autoplay]"),
    );
    var playVid = function (v) {
      var pr = v.play();
      if (pr && pr.catch) pr.catch(function () {});
    };
    vids.forEach(function (v) {
      if (v.readyState >= 2) playVid(v);
      else
        v.addEventListener(
          "loadeddata",
          function () {
            playVid(v);
          },
          { once: true },
        );
    });
    if ("IntersectionObserver" in window) {
      var vio = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) playVid(e.target);
            else e.target.pause();
          });
        },
        { threshold: 0.15 },
      );
      vids.forEach(function (v) {
        vio.observe(v);
      });
    }
  }
})();
